module.exports = __webpack_public_path__ + "static/media/018.328e5832.jpg";